import React from 'react';

const Invoice = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path d="M0 0H32V32H0V0Z" fill="white" />
    <path fillRule="evenodd" clipRule="evenodd" d="M26.9178 1.54795H9.24655V26.2055H26.9178V1.54795ZM27.4657 1V26.7534H8.69861V1H27.4657Z" fill="#8CE4DB" />
    <path d="M27.4657 1H8.69861V2.78082H27.4657V1Z" fill="#8CE4DB" />
    <path d="M23.7671 5.24658H5V31H23.7671V5.24658Z" fill="white" />
    <path fillRule="evenodd" clipRule="evenodd" d="M23.2192 5.79453H5.54795V30.4521H23.2192V5.79453ZM23.7671 5.24658V31H5V5.24658H23.7671Z" fill="#8CE4DB" />
    <path d="M23.7671 5.24658H5V7.0274H23.7671V5.24658Z" fill="#8CE4DB" />
    <path d="M21.8493 10.1781H7.05478V11.4109H21.8493V10.1781Z" fill="#B4B4ED" />
    <path d="M21.8493 12.6438H7.05478V13.8767H21.8493V12.6438Z" fill="#B4B4ED" />
    <path d="M21.8493 15.1096H7.05478V16.3425H21.8493V15.1096Z" fill="#B4B4ED" />
  </svg>

);

export default Invoice;
